import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const OmtScroll = () => {
  const ref = useRef(null);
  const { scrollYProgress: p } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const strike = useTransform(p, [0.1, 0.35], ["0%", "100%"]);
  const oldY = useTransform(p, [0.35, 0.6], [0, -40]);
  const oldScale = useTransform(p, [0.35, 0.6], [1, 0.55]);
  const oldOpacity = useTransform(p, [0.35, 0.6], [1, 0.3]);
  const newOpacity = useTransform(p, [0.45, 0.7], [0, 1]);
  const newScale = useTransform(p, [0.45, 0.8], [1.4, 1]);
  const newBlur = useTransform(p, [0.45, 0.75], ["blur(24px)", "blur(0px)"]);
  const glow = useTransform(p, [0.7, 1], [0, 0.5]);
  const hint = useTransform(p, [0, 0.15], [1, 0]);
  const eyebrow = useTransform(p, [0.3, 0.45], [1, 0]);

  return (
    <div ref={ref} data-testid="omt-scroll" className="relative h-[260vh]">
      <div className="sticky top-0 flex h-screen flex-col items-center justify-center overflow-hidden text-center">
        <motion.div style={{ opacity: glow }} className="pointer-events-none absolute h-[60vh] w-[60vh] rounded-full bg-[#C9A96E] blur-[140px]" />
        <motion.p style={{ opacity: eyebrow }} className="relative text-sm font-bold tracking-[0.5em] text-[#C9A96E]">ONE MORE THING</motion.p>
        <h2 data-testid="omt-title" className="relative mt-8 font-black leading-none">
          <motion.span style={{ y: oldY, scale: oldScale, opacity: oldOpacity }} className="block text-[18vw] text-white md:text-[11rem]">
            <span className="relative inline-block">
              運動飯店
              <motion.span style={{ width: strike }} className="absolute left-0 top-1/2 h-[0.08em] -translate-y-1/2 rounded-full bg-[#C9A96E]" />
            </span>
          </motion.span>
          <motion.span style={{ opacity: newOpacity, scale: newScale, filter: newBlur }} className="block bg-gradient-to-b from-[#F6E7C1] to-[#C9A96E] bg-clip-text text-[20vw] text-transparent md:text-[13rem]">
            抗老飯店
          </motion.span>
        </h2>
        <motion.p style={{ opacity: hint }} className="absolute bottom-10 text-xs tracking-[0.3em] text-white/40">向下捲動</motion.p>
      </div>
    </div>
  );
};
